import ApprovalProvider from 'innovate/components/ApprovalProvider';
import SurveyPopup from 'innovate/components/common/SurveyPopup';
import { ReactNode } from 'react';

interface WithApprovalProviderOptions {
  survey?: boolean;
}

const withApprovalProvider = (Component: ReactNode, options: WithApprovalProviderOptions = {}) => {
  const WithApprovalProvider = () => (
    <ApprovalProvider>
      {Component}
      {options.survey ? <SurveyPopup /> : null}
    </ApprovalProvider>
  );
  return WithApprovalProvider;
};

export default withApprovalProvider;
